import React from 'react'
import { TableComponent as Table } from '../../components'
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import moment from 'moment'
import { getContractTypeName, getDisplayContractName } from '../../utils/functions'

const WithdrawlsTable = (props) => {
    const { data } = props
    
    const columns = [
        {
            title: 'Nome',
            dataIndex: 'Contrato',
            key: 'nome',
            align: 'center',
            render: (c, record) => {
                const nome = c?.Cliente?.nome || record?.usuario?.nome || '-';
                return nome;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
                return <>
                        <Input 
                            autoFocus 
                            placeholder="Ex.: João da Silva" 
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => { confirm() }}
                            onBlur={() => { confirm() }}
                        />
                    </>

            },
            filterIcon: () => {
                return <SearchOutlined />
            },
            onFilter: (value, record) => {
                const nome = (record?.Contrato?.Cliente?.nome || record?.usuario?.nome || '').toLowerCase();
                return nome.includes(String(value).toLowerCase());
            },
        },
        {
            title: 'Contrato',
            dataIndex: 'Contrato',
            key: 'tipoContrato',
            align: 'center',
            render: (c, record) => {
                const nomeTipoContrato = record?.contrato?.tipoContratoNome || c?.tipoContratoNome;
                const tipoContrato = (record?.Contrato?.tipoContrato ?? record?.contrato?.tipoContrato ?? (record?.tipo === 'spirit' ? 6 : record?.tipo === 'asa' ? 1 : undefined));
                return getDisplayContractName(nomeTipoContrato, tipoContrato);
            },
            filters: [
                { text: 'RLY', value: [6, 19] },
                { text: 'BATS', value: [22] },
                { text: 'RFY', value: [1,2,3,4,5,7,8,9,10,11,12,13,14]}
            ],
            onFilter: (value, record) => {
                const tipoContrato = record?.Contrato?.tipoContrato ?? record?.contrato?.tipoContrato ?? (record?.tipo === 'spirit' ? 6 : record?.tipo === 'asa' ? 1 : undefined);
                return value.indexOf(tipoContrato) !== -1;
            }
        },
        {
            title: 'Valor',
            dataIndex: 'valor',
            key: 'value',
            align: 'center',
            render: v => 'R$ '+v,
            sorter: (a, b) => a.valor - b.valor,
        },
        {
            title: 'Data solicitação',
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            render: date => moment(date).format("DD/MM/YYYY")
        },
        {
            title: 'Data aprovação',
            dataIndex: 'dataAprovacao',
            key: 'dataAprovacao',
            align: 'center',
            render: date => moment(date).format("DD/MM/YYYY")
        },
        {
            title: 'Data cotização',
            dataIndex: 'dataCotizacao',
            key: 'dataCotizacao',
            align: 'center',
            render: date => moment(date).format("DD/MM/YYYY")
        },
        {
            title: 'Data cotização',
            dataIndex: 'dataTransferencia',
            key: 'dataTransferencia',
            align: 'center',
            render: date => moment(date).format("DD/MM/YYYY")
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: status => status === 4 ? 'Negado' : 'Aprovado',
            filters: [
                { text: 'Aprovado', value: [3] },
                { text: 'Negado', value: [4]}
            ],
            onFilter: (value, record) => value.indexOf(record.status) !== -1
        }
    ]
    return (
        <Table column={columns} data={data} />
    )
}

export default WithdrawlsTable